import { todayIso } from "./rolloFormat";

// Release the object URL a moment after the click so every browser has started the download.
const REVOKE_DELAY_MS = 1000;

// Same name as the server's Content-Disposition, for when the header is missing.
export const fallbackExportName = (now = new Date()) => `Rollo_Finalizadas_${todayIso(now).replace(/-/g, "")}.xlsx`;

// Warning for a file the server cut at its row limit: rows written (X-Rollo-Export-Rows) of the matching total.
// The client does not know the limit, so without the rows it says only that part of them went out.
export const truncationMessage = ({ rows, total }) =>
  rows === null || rows === undefined
    ? `Se exportó una parte de las ${total} gestiones. Ajustá los filtros para exportar el resto.`
    : `Se exportaron las primeras ${rows} de ${total} gestiones. Ajustá los filtros para exportar el resto.`;

// Downloads a blob with a temporary link.
export const saveBlob = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), REVOKE_DELAY_MS);
};
